/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AggregateKeyInfo } from './AggregateKeyInfo';
import {
    AggregateKeyInfoFromJSON,
    AggregateKeyInfoFromJSONTyped,
    AggregateKeyInfoToJSON,
} from './AggregateKeyInfo';
import type { BooleanSearch } from './BooleanSearch';
import {
    BooleanSearchFromJSON,
    BooleanSearchFromJSONTyped,
    BooleanSearchToJSON,
} from './BooleanSearch';
import type { Int32ListSearch } from './Int32ListSearch';
import {
    Int32ListSearchFromJSON,
    Int32ListSearchFromJSONTyped,
    Int32ListSearchToJSON,
} from './Int32ListSearch';
import type { TextSearch } from './TextSearch';
import {
    TextSearchFromJSON,
    TextSearchFromJSONTyped,
    TextSearchToJSON,
} from './TextSearch';

/**
 * 
 * @export
 * @interface ClauseSearch
 */
export interface ClauseSearch {
    /**
     * 
     * @type {TextSearch}
     * @memberof ClauseSearch
     */
    title?: TextSearch;
    /**
     * 
     * @type {TextSearch}
     * @memberof ClauseSearch
     */
    description?: TextSearch;
    /**
     * 
     * @type {Int32ListSearch}
     * @memberof ClauseSearch
     */
    idstade?: Int32ListSearch;
    /**
     * 
     * @type {BooleanSearch}
     * @memberof ClauseSearch
     */
    actif?: BooleanSearch;
    /**
     * 
     * @type {Array<number>}
     * @memberof ClauseSearch
     */
    selectedIds?: Array<number> | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof ClauseSearch
     */
    availableIds?: Array<number> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof ClauseSearch
     */
    sortKey?: Array<string> | null;
    /**
     * 
     * @type {Array<AggregateKeyInfo>}
     * @memberof ClauseSearch
     */
    aggregateKeys?: Array<AggregateKeyInfo> | null;
    /**
     * 
     * @type {number}
     * @memberof ClauseSearch
     */
    forceSkip?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ClauseSearch
     */
    forceTake?: number | null;
    /**
     * 
     * @type {any}
     * @memberof ClauseSearch
     */
    parameters?: any | null;
    /**
     * 
     * @type {string}
     * @memberof ClauseSearch
     */
    filter?: string | null;
}

/**
 * Check if a given object implements the ClauseSearch interface.
 */
export function instanceOfClauseSearch(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ClauseSearchFromJSON(json: any): ClauseSearch {
    return ClauseSearchFromJSONTyped(json, false);
}

export function ClauseSearchFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClauseSearch {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'title': !exists(json, 'title') ? undefined : TextSearchFromJSON(json['title']),
        'description': !exists(json, 'description') ? undefined : TextSearchFromJSON(json['description']),
        'idstade': !exists(json, 'idstade') ? undefined : Int32ListSearchFromJSON(json['idstade']),
        'actif': !exists(json, 'actif') ? undefined : BooleanSearchFromJSON(json['actif']),
        'selectedIds': !exists(json, 'selectedIds') ? undefined : json['selectedIds'],
        'availableIds': !exists(json, 'availableIds') ? undefined : json['availableIds'],
        'sortKey': !exists(json, 'sortKey') ? undefined : json['sortKey'],
        'aggregateKeys': !exists(json, 'aggregateKeys') ? undefined : (json['aggregateKeys'] === null ? null : (json['aggregateKeys'] as Array<any>).map(AggregateKeyInfoFromJSON)),
        'forceSkip': !exists(json, 'forceSkip') ? undefined : json['forceSkip'],
        'forceTake': !exists(json, 'forceTake') ? undefined : json['forceTake'],
        'parameters': !exists(json, 'parameters') ? undefined : json['parameters'],
        'filter': !exists(json, 'filter') ? undefined : json['filter'],
    };
}

export function ClauseSearchToJSON(value?: ClauseSearch | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'title': TextSearchToJSON(value.title),
        'description': TextSearchToJSON(value.description),
        'idstade': Int32ListSearchToJSON(value.idstade),
        'actif': BooleanSearchToJSON(value.actif),
        'selectedIds': value.selectedIds,
        'availableIds': value.availableIds,
        'sortKey': value.sortKey,
        'aggregateKeys': value.aggregateKeys === undefined ? undefined : (value.aggregateKeys === null ? null : (value.aggregateKeys as Array<any>).map(AggregateKeyInfoToJSON)),
        'forceSkip': value.forceSkip,
        'forceTake': value.forceTake,
        'parameters': value.parameters,
        'filter': value.filter,
    };
}

